import { DetailManyToOne } from '@/@diffrag/form/DetailManyToOne'
import { DetailManyToOneTable } from '@/@diffrag/form/DetailManyToOneTable'
import { FormFieldType } from '@/@diffrag/form/fields/type'
import { useApi } from '@/@diffrag/hooks/useApi'
import { ContentDetailView } from '@/@diffrag/layout/ContentDetailView'
import { ContentView } from '@/@diffrag/layout/ContentView'
import { SimpleTable } from '@/@diffrag/table/SimpleTable'
import { api } from '@/api'
import { AdminFaqListData } from 'api'

export default function FaqEdit() {
  const { data, isFetching } = useApi({
    id: 'faqList',
    fn: api().adminFaq.adminFaqList,
  })

  const onSave = async (rows: AdminFaqListData) => {
    const deletedItems = data?.items.filter(
      (item) => !rows.items.some((rowItem) => rowItem.id === item.id),
    )

    if (deletedItems?.length) {
      await api().adminFaq.adminFaqDelete({
        ids: deletedItems.map((item) => item.id),
      })
    }

    for (const row of rows.items) {
      if (row.id) {
        await api().adminFaq.adminFaqUpdate(row.id, {
          question: row.question,
          answer: row.answer,
          order: row.order,
        })
      } else {
        await api().adminFaq.adminFaqCreate({
          question: row.question,
          answer: row.answer,
          order: row.order,
        })
      }
    }
  }

  const onDelete = async (rows: AdminFaqListData) => {
    await api().adminFaq.adminFaqDelete({
      ids: rows.items.map((item) => item.id),
    })
  }

  return (
    <ContentDetailView title="자주묻는질문" data={data} onSave={onSave}>
      <DetailManyToOne
        name="items"
        title="자주묻는질문"
        addButtonText="등록하기"
        getFields={() => [
          {
            label: '순서',
            key: 'order',
            type: FormFieldType.REORDER,
          },
          {
            label: '질문',
            key: 'question',
            type: FormFieldType.STRING,
          },
          {
            label: '답변',
            key: 'answer',
            type: FormFieldType.CKEDITOR,
          },
        ]}
      />
    </ContentDetailView>
  )
}
